import { createContext } from "react";

const NavbarContext = createContext();

export default NavbarContext;